import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Dots.scss';

function Dots(props) {
    const {
        classes: classesProp = {},
    } = props;

    const classes = combineClasses(classesProp, styles);

    return (
        <div className={classNames(classes.container)} />
    );
}

Dots.propTypes = {
    classes: PropTypes.object,
};

export default Dots;
